module.exports = __webpack_public_path__ + "media/bg.524f9baf.mp4";